import styles from './Tag.module.css';

interface TagsProps {
  label: string;
  color: string;
  textColor?: string;
}

export function Tag({ label, color, textColor = 'black' }: TagsProps) {
  return (
    <div className={styles.tag} style={{ borderColor: color }}>
      <span className={styles.circle} style={{ backgroundColor: color }} />
      <span className={styles.label} style={{ color: textColor }}>
        {label}
      </span>
    </div>
  );
}
